// Libraries
var React = require('react');
var extend = require('lodash/extend');
var $ = require('jquery');

// Styles
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require('./GridGalleryCarousel.scss');

class GridGalleryCarousel extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			preview: true
		}

		this.baseSettings = {
			accessibility: true,
			dots: true,
			infinite: true,
			arrows: true,
			speed: 500,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			initialSlide: this.props.initialSlide,
			fade: true
		};

		this.settings = null;
		this.mergeSettings(this.props.data.settings);
	}

	componentDidMount() {
		// this is here to prevent window being undefined when rendered server side
		require('slick-carousel');

		var gallery = $(this.imgGallery);
		gallery.on('init', (_event, _slick, _currentSlide, nextSlide) => {
			gallery.find('.slick-active button').focus();
		});
		gallery.not('.slick-initialized').slick(this.settings);
	}

	componentWillUnmount() {
		$(this.imgGallery).slick('unslick');
	}

	mergeSettings(settings) {
		if(settings != null) {
			this.settings = extend(this.baseSettings, this.props.data.settings);
		} else {
			this.settings = this.baseSettings;
		}
	}

	componentDidUpdate(nextProps) {
		this.mergeSettings(nextProps.data);
	}

	render() {
		return (
			<div className={`c-grid-gallery-carousel ${
				this.props.data.isPremium ? " c-grid-gallery-carousel--premium" : ""
			  }`} id={this.props.data.id || null}>
				<div className="c-grid-gallery-carousel__wrapper">
					<div className="c-grid-gallery-carousel__wrapper-inner" ref={g => this.imgGallery = g}>
						{this.props.data.slides.length > 0 && this.props.data.slides.map((item, index) => {
							return(
								<div className="c-grid-gallery-carousel__slide" key={index}>
									<picture>
										<source media="(min-width: 1600px)" srcSet={item.image.extraLargeUrl} />
										<source media="(min-width: 1400px)" srcSet={item.image.largeUrl} />
										<source media="(min-width: 1024px)" srcSet={item.image.mediumUrl} />
										<img src={item.image.smallUrl} alt={item.imageAltText || item.image.altText} loading="lazy" />
									</picture>
									<div className="overlay"></div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		)
	}
}

module.exports = GridGalleryCarousel;



// WEBPACK FOOTER //
// ./src/components/GridGallery/GridGalleryCarousel.js